'use client'

import DOMPurify from 'dompurify'
import React from 'react'

import longMedanteWaveSand from '../../../assets/wave/long-medante-wave-sand-02.svg'
import { cn } from '../../../utils/cn'

import { TextAContent, TextAImages, TextAIllustration } from './_components'

import type { IMTextAProps } from './_types/types'

/**
 * MTextA – presentational text section.
 * Flexible layout with title, content, buttons, and optional images.
 * Supports reverse layout and illustration overlay.
 * Responsive (stacked on mobile, side-by-side on lg).
 */
export const MTextA: React.FC<IMTextAProps> = ({
	className,
	style,
	title,
	content,
	buttons,
	images,
	illustration,
	reverse = false
}) => {
	const sanitizedTitle = typeof window !== 'undefined' ? DOMPurify.sanitize(title ?? '') : title
	const sanitizedContent =
		typeof window !== 'undefined' ? DOMPurify.sanitize(content ?? '') : content

	return (
		<section
			className={cn('m-text-a', reverse && 'm-text-a--reverse', className)}
			style={style}
		>
			<div className='m-text-a__container'>
				<div className='m-text-a__column m-text-a__column--content'>
					<TextAContent
						title={sanitizedTitle}
						content={sanitizedContent}
						buttons={buttons}
					/>
				</div>
				{images && images.length > 0 && (
					<div className='m-text-a__column m-text-a__column--images'>
						<TextAImages images={images} />
					</div>
				)}
			</div>

			{illustration && <TextAIllustration src={longMedanteWaveSand} alt='' />}
		</section>
	)
}

MTextA.displayName = 'MTextA'
